import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Form } from 'react-bootstrap';
import accountApi from '../services/accountApi';
import bakeonatorLogo from '../assets/images/logos/bakeonator_logo.png';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [devResetUrl, setDevResetUrl] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    setDevResetUrl(null);
    try {
      const result = await accountApi.requestPasswordReset({ email });
      setSubmitted(true);
      if (result && result.development_reset_url) {
        setDevResetUrl(result.development_reset_url);
      }
    } catch (err) {
      setError(err.message || 'Unable to process request');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-body text-center">
              <img
                src={bakeonatorLogo}
                alt="Bakeonator Logo"
                width="auto"
                height="100"
                className="mx-auto d-block mb-3"
              />
              <h2 className="card-title mb-4">Forgot password</h2>

              {submitted ? (
                <>
                  <Alert variant="success">
                    If an eligible account exists, password-reset instructions have been sent.
                  </Alert>
                  {devResetUrl && (
                    <Alert variant="warning" className="text-start">
                      Development-only reset link:{' '}
                      <a href={devResetUrl}>{devResetUrl}</a>
                    </Alert>
                  )}
                  <Link to="/login" className="btn btn-primary">
                    Back to sign in
                  </Link>
                </>
              ) : (
                <>
                  <p className="text-muted small mb-3">
                    Enter your email and we will send reset instructions if an account exists.
                  </p>
                  {error && <Alert variant="danger">{error}</Alert>}
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3 text-start">
                      <Form.Label htmlFor="email">Email</Form.Label>
                      <Form.Control
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <div className="d-grid mb-3">
                      <Button type="submit" disabled={submitting}>
                        {submitting ? 'Sending…' : 'Send reset link'}
                      </Button>
                    </div>
                  </Form>
                  <Link to="/login" className="small">
                    Back to sign in
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
